export default __webpack_public_path__ + "static/media/wSkirt_1_p4.037c25e4.jpeg";